import { useEffect, useState } from "react";
import { createInvestment } from "./InvestmentService";
import { apiFetch } from "../../api";
import { getAllAccounts } from "../accounts/AccountService";

export default function FDForm(){

  const [accounts,setAccounts] = useState([]);
  const [form,setForm] = useState({
    investmentType:"FD",
    accountId:"",
    name:"",
    provider:"",
    principal:"",
    interestRate:"",
    startDate:"",
    maturityDate:""
  });

  useEffect(()=>{
    loadAccounts();
  },[]);

  const loadAccounts = async ()=>{
    setAccounts(await getAllAccounts());
  };

  const submit = async (e)=>{
    e.preventDefault();
    await createInvestment(form);
    alert("FD Created");
  };

  return (
    <div className="card">
      <div className="card-title">Create Fixed Deposit (FD)</div>

      <form onSubmit={submit} className="form-grid">

        <select className="input" onChange={e=>setForm({...form,accountId:e.target.value})}>
          <option value="">Select Account</option>
          {accounts.map(a=><option key={a.id} value={a.id}>{a.accountName}</option>)}
        </select>

        <input className="input" placeholder="FD Name"
          onChange={e=>setForm({...form,name:e.target.value})} />

        <input className="input" placeholder="Bank / Provider"
          onChange={e=>setForm({...form,provider:e.target.value})} />

        <input className="input" type="number" placeholder="Principal Amount"
          onChange={e=>setForm({...form,principal:e.target.value})} />

        <input className="input" type="number" placeholder="Interest Rate %"
          onChange={e=>setForm({...form,interestRate:e.target.value})} />

        <input className="input" type="date"
          onChange={e=>setForm({...form,startDate:e.target.value})} />

        <input className="input" type="date"
          onChange={e=>setForm({...form,maturityDate:e.target.value})} />

        <div className="form-full" style={{ textAlign:"right" }}>
          <button className="btn btn-primary">Create FD</button>
        </div>

      </form>
    </div>
  );
}
